import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DadosGerais from "../../components/Processo/Abas/DadosGerais.js";
import Historico from "../../components/Processo/Detalhes/Historico";
import Etapa from "../../components/Processo/Detalhes/Etapa.js";
import Anexos from "../../components/Processo/Abas/Anexos.js";
import Parecer from "../../components/Processo/Abas/Parecer";
import Layout from "../../components/Layout.js";
import ProgressBarList from "../../components/ProgressBarList.js";
import "../../assets/styles/pages/Processo/Detalhes.scss";
import business from "../../services/business.js";
import ModalProcesso from "../../components/Modais/ModalProcesso.js";
import layout from "../../lib/layout.js";
import tools from "../../lib/tools.js";
import config from "../../config/config.js";
import Preloader from "../../components/Preloader.js";
import moment from "moment-timezone";
import ModalResponsaveis from "../../components/Modais/ModalResponsaveis.js";
import ModalConvidados from "../../components/Modais/ModalConvidados.js";
import { toast as alert } from "react-toastify";
import DadosProcesso from "../../components/Processo/Abas/DadosProcesso.js";
import ModalAlert from "../../components/Modais/ModalAlert.js";
import Chat from "../../components/Processo/Abas/Chat.js";
import Comunicacoes from "../../components/Processo/Abas/Comunicacoes.js";
import NaoAutorizado from "../../components/NaoAutorizado.js";
import createPushClient from "../../lib/pushClient.js";
import ModalTrocaEtapa from "../../components/Modais/ModalTrocaEtapa.js";

moment.tz.setDefault("America/Sao_Paulo");

export default function DetProcesso({ name }) {
  const defaultValues = {
    id_area_atuacao: "",
    id_operadora: "",
    id_plano: "",
    desc_operadora: "",
    id_processo_tipo: "",
    id_processo_tipo_atendimento: "",
    beneficiario: {
      cpf: "",
      nome: "",
      nascimento: "",
      sexo: "",
      telefone: "",
      telefone2: "",
      email: "",
      email2: "",
      cep: "",
      rua: "",
      numero: "",
      cidade: "",
      bairro: "",
      uf: "",
      carteirinha: "",
    },
    profissional: {
      crm: "",
      nome: "",
      telefone: "",
      telefone2: "",
      email: "",
      email2: "",
    },
    procedimentos: [],
    materiais: [],
    anexos: [],
  };


  let { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const hash = location.hash?.replace("#", "");

  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [processoLoaded, setProcessoLoaded] = useState(false);
  const [validacao, setValidacao] = useState({});
  const [updateStatus, setUpdateStatus] = useState(false);
  const [options, setOptions] = useState({});
  const [form, setForm] = useState(defaultValues);
  const [render, setRender] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [scroll, setScroll] = useState(0);
  const [showNext, setShowNext] = useState(true);
  const [etapaAtual, setEtapa] = useState({});
  const [salvandoDados, setSalvandoDados] = useState(false);
  const [comentario, setComentario] = useState();

  const [showModalResponsaveis, setShowModalResponsaveis] = useState(false);
  const [showModalConvidados, setShowModalConvidados] = useState(false);
  const [showModalTrocaEtapa, setShowModalTrocaEtapa] = useState(false);
  const [modalData, setModalData] = useState({});

  const voltar = (e) => {
    navigate(`/${name}`);
  };

  const setScrollStatus = (voltar = false) => {
    let status = document.getElementById("container-status");
    if (voltar) {
      status.scrollLeft -= 265;
    } else {
      status.scrollLeft += 265;
    }
    setShowNext(status.scrollWidth - status.clientWidth !== status.scrollLeft);
    setScroll(status.scrollLeft);
  };

  window.addEventListener("resize", (e) => {
    let status = document.getElementById("container-status");
    if (status && status.length) {
      setShowNext(
        status.scrollWidth - status.clientWidth !== status.scrollLeft
      );
      setScroll(status.scrollLeft);
    }
  });

  const openModal = (event) => {
    event?.preventDefault();
    setShowModal(true);
  };

  const hideModal = (event) => {
    event?.preventDefault();
    setShowModal(false);
  };

  const openModalResponsaveis = async (event = {}) => {
    event?.preventDefault();
    setShowModalResponsaveis(true);
  };
  const hideModalResponsaveis = async (event) => {
    event?.preventDefault();
    setShowModalResponsaveis(false);
  };

  const openModalTrocaEtapa = (event = {}) => {
    event?.preventDefault();
    setShowModalTrocaEtapa(true);
  };

  const hideModalTrocaEtapa = (event) => {
    event?.preventDefault();
    setShowModalTrocaEtapa(false);
  };

  const openModalConvidados = async (event = {}) => {
    event?.preventDefault();
    setShowModalConvidados(true);
  };
  const hideModalConvidados = async (event) => {
    event?.preventDefault();
    setShowModalConvidados(false);
  };

  const [abas, setAbas] = useState([]);

  const [aba, setAba] = useState(
    [
      "dados",
      "processo",
      "parecer",
      "comunicaoes",
      "comentarios",
      "anexos",
    ].includes(hash)
      ? hash
      : "dados"
  );

  const setModel = (name, value) => {
    let keys = name?.split(".") || false;
    if (keys && keys.length > 1) {
      name = keys[0];
      value = { ...form[name], ...{ [keys[1]]: value } };
    }
    if (name === "form") {
      setForm((prevState) => ({ ...prevState, ...value }));
    } else {
      setForm((prevState) => ({ ...prevState, ...{ [name]: value } }));
    }
  };

  const reloadProcesso = useCallback(async () => {
    if (!id) return;
    try {
      let proc = await business.getProcesso(id);
      if (!proc?.id) return;
      proc = tratarProcesso(proc);
      setForm(proc);
      setAbas(proc?.abas || []);
      setRender(tools.uuidv4());
    } catch (err) {
      console.error('Erro ao recarregar processo:', err);
      alert.error('Não foi possível recarregar o processo.');
    }
  }, [id]);

  const abaActive = () => {
    let abaAtual = abas.find((aba_item) => aba_item.id === aba) || {};

    switch (aba) {
      case "anexos":
        return (
          <Anexos
            form={form}
            validacao={validacao}
            setModel={setModel}
            options={options}
            permitirEdicao={temPermissao(abaAtual, "anexos:editar")}
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
      case "processo":
        return (
          <DadosProcesso
            salvar={salvar}
            form={form}
            validacao={validacao}
            setModel={setModel}
            options={options}
            permitirEdicao={temPermissao(abaAtual, "processo:editar")}
            updateStatus={updateStatus}
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
      case "parecer":
        return <Parecer form={form} options={options} setForm={setModel} />;
      case "comunicacoes":
        return (
          <Comunicacoes
            form={form}
            options={options}
            setModel={setModel}
            idComentario={comentario?.id}
          />
        );
      case "comentarios":
        return <Chat id={id} options={options} idComentario={comentario?.id} />;
      default:
        return (
          <DadosGerais
            salvar={salvar}
            form={form}
            startDate={form?.inicio_processo}
            expireDate={form?.expiracao_processo}
            ansDate={form?.data_ans}
            permitirEdicao={temPermissao(abaAtual, "dados:editar")}
            validacao={validacao}
            setModel={setModel}
            options={options}
            updateStatus={updateStatus}
            className="f600-18 mh-20 mt-20 mb-30"
          />
        );
    }
  };

  const title = layout.title(name);

  const [diasAteInicio, setDiasAteInicio] = useState(0);
  const [diasANS, setDiasANS] = useState(0);
  const [diasSaasto, setDiasSaasto] = useState(0);

  config.onChange = () => {
    setRender(tools.uuidv4());
  };

  const simularAvancoEtapas = false;

  const avancarEtapa = async (data, setError) => {
    let formData = tools.clone(form);

    formData.id_processo_etapa_origem = formData.id_processo_etapa || 0;
    formData.id_processo_etapa_status_origem =
      formData.id_processo_etapa_status || 0;
    formData.id_processo_etapa_status_selecionado = data?.status || 0;

    let statusSelecionado = etapaAtual.status_permitidos.find((status) => {
      return parseInt(status.id) === parseInt(data.status);
    });

    let proximaEtapa = form.etapas.find((etapa) => {
      return (
        statusSelecionado?.proxima_etapa &&
        parseInt(etapa.id) === parseInt(statusSelecionado?.proxima_etapa)
      );
    });

    let proximoStatus = proximaEtapa?.status_permitidos.find((etapa) => {
      return (
        statusSelecionado?.proximo_status &&
        parseInt(etapa.id) === parseInt(statusSelecionado?.proximo_status)
      );
    });

    if (proximaEtapa && proximoStatus) {
      formData.id_processo_etapa = proximaEtapa.id;
      formData.desc_processo_etapa = proximaEtapa.nome;
      formData.id_processo_etapa_status = proximoStatus.id;
      formData.desc_processo_etapa_status = proximoStatus.desc;
    } else if (statusSelecionado) {
      formData.id_processo_etapa_status = statusSelecionado.id;
      formData.desc_processo_etapa_status = statusSelecionado.desc;
    } else {
      setError((prevState) => ({
        ...prevState,
        status: "Selecione um status para continuar",
      }));

      return false;
    }

    if (
      formData &&
      [9].includes(parseInt(form.id_processo_etapa)) &&
      [16, 35, 49, 10948].includes(parseInt(data.status)) &&
      !data?.id_desempatador &&
      !data?.auto_escolher_desempatador
    ) {
      setError((prevState) => ({
        ...prevState,
        id_desempatador: "Selecione um desempatador para continuar",
      }));

      return false;
    }

    if (
      formData &&
      [6].includes(parseInt(form.id_processo_etapa)) &&
      [30607].includes(parseInt(data.status)) &&
      !data?.id_assistente
    ) {
      setError((prevState) => ({
        ...prevState,
        id_assistente: "Selecione um assistente para continuar",
      }));

      return false;
    }

    if (data?.id_desempatador) {
      formData.id_desempatador = data?.id_desempatador;
    }

    if (data?.id_assistente) {
      formData.id_assistente = data?.id_assistente;
    }

    setError({});

    let etapaAtiva;

    formData.etapas = formData.etapas.map((etapa) => {
      if (parseInt(formData.id_processo_etapa) === parseInt(etapa.id)) {
        etapaAtiva = etapa.id;
        etapa.ativa = true;
        etapa.descricao = formData.desc_processo_etapa_status;
        etapa.porcentagem = 40;
      } else if (etapaAtiva) {
        etapa.ativa = false;
        etapa.descricao = "Na fila";
        etapa.porcentagem = 0;
      } else {
        etapa.ativa = false;
        etapa.descricao = "Concluída";
        etapa.porcentagem = 100;
      }
      return etapa;
    });

    if (simularAvancoEtapas) {
      setForm(formData);
      hideModal();
    } else {
      setSalvandoDados(true);

      if ((Number(data.status) === 3 || Number(data.status) === 4) && data.comentario.length < 1) {
        alert.error("Comentário não pode estar vazio!");
        setSalvandoDados(false);
        return;
      } else if ((Number(data.status) === 3 || Number(data.status) === 4) && data.comentario.length > 0) {
        let commentario = {
          id_processo: id,
          texto: data.comentario,
        };

        const { response } = await business.addComunicacao(commentario);

        if (response?.id) {
          setComentario(response);
        }

        // reset
        data.comentario = "";
      }

      formData.procedimentos =
        form.procedimentos?.map((item_p) => {
          item_p.data.valor_unitario = tools.prepareValue(
            item_p.data?.valor_unitario || 0
          );
          return { ...item_p.data, ...item_p.procedimento }
        }) || [];
      formData.materiais =
        form.materiais?.map((item_m) => {
          item_m.data.valor_unitario = tools.prepareValue(
            item_m.data?.valor_unitario || 0
          );
          return { ...item_m.data, ...item_m.material }
        }) || [];
      formData.valor_total = tools.prepareValue(form.valor_total);

      const { response, errors } = await business.processo(formData, form?.id);

      if (errors && errors?.length) {
        (errors || ["Ocorreu um erro ao tentar realizar ação"]).forEach((e) =>
          alert.error(e)
        );
        setSalvandoDados(false);
      } else {
        formData.permissoes = response?.permissoes ?? [];
        formData = tratarProcesso(formData);

        await business.putResponsaveis({ id_assistente: formData.id_assistente }, form?.id);
        formData.id_processo_etapa_origem = formData.id_processo_etapa || 0;
        formData.id_processo_etapa_status_origem =
          formData.id_processo_etapa_status || 0;
        formData.id_processo_etapa_status_selecionado = formData.id_processo_etapa_status || 0;
        setForm(formData);
        setAbas(response?.abas || []);
        setRender();
        hideModal();
        setSalvandoDados(false);
      }
    }
  };

  // eslint-disable-next-line
  const temPermissao = (abaAtual, key) => {
    return (abaAtual?.permissoes || []).includes(key);
  };

  const focusInput = (name) => {
    if (!document.getElementsByName(name)?.length) {
      return;
    }
    document.getElementsByName(name)[0].focus();
  };

  const salvar = async (e, stage) => {
    e.preventDefault();

    const obrigatorios = [];

    document.querySelectorAll("main [name][required]").forEach((e) => {
      if (e.name && e.style.display !== "none") obrigatorios.push(e.name);
    });

    let validacao = {};
    let validated = true;
    let first = false;

    switch (stage) {
      case 1:
        obrigatorios.forEach((campo, index) => {
          let keys = campo.split(".");
          if (keys.length === 2) {
            if (
              typeof form[keys[0]][keys[1]] === "undefined" ||
              tools.isEmptyNullOrUndefined(form[keys[0]][keys[1]])
            ) {
              validacao[campo] = "Campo Obrigatório";
              validated = false;
              if (!first) {
                focusInput(campo);
                first = true;
              }
            } else if (["cpf"].includes(keys[1])) {
              let validCpf = tools.validarCPF(form[keys[0]][keys[1]]);
              if (!validCpf.valido) {
                validacao[campo] = validCpf.texto;
                validated = false;
              }
            } else if (["email"].includes(keys[1])) {
              let validEmail = tools.validarEmail(form[keys[0]][keys[1]]);
              if (!validEmail) {
                validacao[campo] = "Digite um e-mail válido";
                validated = false;
              }
            } else if (["telefone"].includes(keys[1])) {
              let validarTelefone = tools.validarTelefone(
                form[keys[0]][keys[1]]
              );
              if (!validarTelefone) {
                validacao[campo] = "Digite um telefone válido";
                validated = false;
              }
            } else if (["nascimento"].includes(keys[1])) {
              let validarData = tools.validarData(
                form[keys[0]][keys[1]]
              );
              if (!validarData) {
                validacao[campo] = "Digite uma data válida.";
                validated = false;
              }
            }
          } else if (keys.length > 2) {
            if (
              typeof form[keys[0]][keys[1]]?.data[keys[2]] === "undefined" ||
              tools.isEmptyNullOrUndefined(
                form[keys[0]][keys[1]]?.data[keys[2]]
              )
            ) {
              validacao[campo] = "Campo Obrigatório";
              validated = false;
            }
          } else if (
            typeof form[campo] == "undefined" ||
            tools.isEmptyNullOrUndefined(form[campo])
          ) {
            validacao[campo] = "Campo Obrigatório";
            validated = false;
          }
        });

        const prestadorNome = String(form?.prestador?.nome || "").trim();
        const prestadorCnpj = String(form?.prestador?.cnpj || "").trim();

        if (prestadorNome || prestadorCnpj) {
          if (!prestadorCnpj) {
            validacao["prestador.cnpj"] = "Campo Obrigatório";
            validated = false;
            if (!first) {
              focusInput("prestador.cnpj");
              first = true;
            }
          } else {
            const validCnpj = tools.validarCNPJ(prestadorCnpj);
            if (!validCnpj.valido) {
              validacao["prestador.cnpj"] = validCnpj.texto;
              validated = false;
              if (!first) {
                focusInput("prestador.cnpj");
                first = true;
              }
            }
          }

          if (!prestadorNome) {
            validacao["prestador.nome"] = "Campo Obrigatório";
            validated = false;
            if (!first) {
              focusInput("prestador.nome");
              first = true;
            }
          }
        }
        setValidacao(validacao);

        if (validated) {
          let payload = { ...form };

          payload.procedimentos =
            form.procedimentos?.map((item_p) => {
              item_p.data.valor_unitario = tools.prepareValue(
                item_p.data.valor_unitario
              );
              return item_p.data;
            }) || [];
          payload.materiais =
            form.materiais?.map((item_m) => {
              item_m.data.valor_unitario = tools.prepareValue(
                item_m.data.valor_unitario
              );
              return item_m.data;
            }) || [];
          payload.valor_total = tools.prepareValue(form.valor_total);

          setUpdateStatus(true);

          const { response, errors } = await business.processo(
            payload,
            form?.id
          );
          if (errors && errors.length) {
            (errors || ["Ocorreu um erro ao tentar realizar ação"]).forEach(
              (e) => alert.error(e)
            );
          } else if (response?.id) {
            form.id = response.id;
            form.id_protocolo = response.id_protocolo;
            form.inicio_processo = response.inicio_processo;
            form.profissional.id = response.profissional.id;
            form.id_prestador = response.id_prestador;
            form.auditor.id = response.auditor.id;
            form.id_processo_etapa = response.id_processo_etapa;
            form.desc_processo_etapa = response.desc_processo_etapa;
            form.id_processo_etapa_status = response.id_processo_etapa_status;
            form.desc_processo_etapa_status =
              response.desc_processo_etapa_status;

            setForm(form);

            alert.success("As informações foram salvas");
          } else {
            alert.error("Ocorreu um erro ao salvar os dados");
          }

          setUpdateStatus(false);
        }

        break;
      case 2:
        if (!form?.materiais?.length && !form?.procedimentos?.length) {
          return setModalData({
            text: "Adicione ao menos um procedimento ou material.",
            show: true,
            buttonCancel: false,
            onAccept: async (e) => {
              setModalData({
                show: false,
              });
            },
          });
        }

        obrigatorios.forEach((campo) => {
          let keys = campo.split(".");

          if (keys.length === 2) {
            if (
              typeof form[keys[0]][keys[1]] === "undefined" ||
              tools.isEmptyNullOrUndefined(form[keys[0]][keys[1]])
            ) {
              validacao[campo] = "Campo Obrigatório";
              validated = false;
              if (!first) {
                focusInput(campo);
                first = true;
              }
            }
          } else if (keys.length > 2) {
            if (
              typeof form[keys[0]][keys[1]]?.data[keys[2]] === "undefined" ||
              tools.isEmptyNullOrUndefined(
                form[keys[0]][keys[1]]?.data[keys[2]]
              )
            ) {
              validacao[campo] = "Campo Obrigatório";
              validated = false;
              focusInput(campo);
            } else if (keys[2] === "observacao" && form[keys[0]][keys[1]]?.data?.observacao.length < 10) {
              validacao[campo] = "Campo deve conter pelo menos 10 caracteres";
              validated = false;
              focusInput(campo);
            }
          } else if (
            typeof form[campo] == "undefined" ||
            tools.isEmptyNullOrUndefined(form[campo])
          ) {
            validacao[campo] = "Campo Obrigatório";
            validated = false;
            focusInput(campo);
          }
        });

        setValidacao(validacao);

        if (validated) {
          let payload = { ...form };

          payload.procedimentos =
            form.procedimentos?.map((item_p) => {
              item_p.data.valor_unitario = tools.prepareValue(
                item_p.data.valor_unitario
              );
              return item_p.data;
            }) || [];
          payload.materiais =
            form.materiais?.map((item_m) => {
              item_m.data.valor_unitario = tools.prepareValue(
                item_m.data.valor_unitario
              );
              return item_m.data;
            }) || [];
          payload.valor_total = tools.prepareValue(form.valor_total);

          setUpdateStatus(true);

          const { response, errors } = await business.processo(
            payload,
            form?.id
          );

          if (errors.length) {
            (errors || ["Ocorreu um erro ao tentar realizar ação"]).forEach(
              (e) => alert.error(e)
            );
          } else {
            form.id = response.id;
            localStorage.setItem("process", JSON.stringify(form));
            alert.success("As informações foram salvas");
          }

          setUpdateStatus(false);
        }
        break;
      case 3:
        break;
      default:
    }

    return validated;
  };

  const enviarProcesso = async (e) => {
    e.preventDefault();

    if (!window.confirm("Você deseja enviar o processo " + form?.id + "?")) {
      return false;
    }

    let payload = { ...form };

    let verificaPendentesEnvio = (payload?.anexos || []).filter((item) => {
      return item.upload === true;
    });

    if (
      !payload?.anexos ||
      !payload?.anexos?.length ||
      verificaPendentesEnvio?.length
    ) {
      return setModalData({
        text: "Adicione ao menos um anexo ao processo.",
        show: true,
        buttonCancel: false,
        onAccept: async (e) => {
          setModalData({
            show: false,
          });
        },
      });
    }

    payload.procedimentos =
      form.procedimentos?.map((item_p) => {
        return item_p.data;
      }) || [];
    payload.materiais =
      form.materiais?.map((item_m) => {
        return item_m.data;
      }) || [];
    payload.id_processo_etapa = 1;
    payload.id_processo_etapa_status = 1;

    setSalvandoDados(true);

    const { response, errors } = await business.processo(payload, form?.id);

    if (errors && errors?.length) {
      (errors || ["Ocorreu um erro ao tentar realizar ação"]).forEach((e) =>
        alert.error(e)
      );
      setSalvandoDados(false);
    } else {
      localStorage.setItem("process", JSON.stringify({}));

      response.permissoes = response?.permissoes ?? [];

      setForm(tratarProcesso(response));
      setAbas(response?.abas || []);
      setRender();
      hideModal();
      setSalvandoDados(false);
    }
  };

  const devolverProcesso = async (e) => {
    e.preventDefault();

    if (!window.confirm("Você deseja devolver este processo à säästö?")) {
      return false;
    }

    let payload = { ...form };
    delete payload.procedimentos;
    delete payload.materiais;
    payload.id_processo_etapa_status = 41;

    setSalvandoDados(true);

    const { response, errors } = await business.processo(payload, form?.id);

    if (errors && errors?.length) {
      (errors || ["Ocorreu um erro ao tentar realizar ação"]).forEach((e) =>
        alert.error(e)
      );
      setSalvandoDados(false);
    } else {
      localStorage.setItem("process", JSON.stringify({}));

      setForm(response);
      setAbas(response?.abas || []);
      setRender();
      hideModal();
      setSalvandoDados(false);
      window.location.reload();
    }
  };

  const tratarProcesso = (processo) => {
    [
      "data_ans",
      "data_atualizacao",
      "data_criacao",
      "expiracao_processo",
      "inicio_processo",
    ].forEach((e) => {
      if (
        processo &&
        typeof processo[e] !== "undefined" &&
        !tools.isEmptyNullOrUndefined(processo[e])
      ) {
        processo[`${e}_original`] = processo[e];
        processo[e] = moment(processo[e]).format("YYYY-MM-DD");
      }
    });
    if (
      processo?.beneficiario &&
      !tools.isEmptyNullOrUndefined(processo.beneficiario?.nascimento)
    ) {
      processo.beneficiario.nascimento = moment(
        processo.beneficiario.nascimento
      ).format("YYYY-MM-DD");
    }

    if (processo?.procedimentos)
      processo.procedimentos = processo?.procedimentos?.map((item) => {
        return {
          id: item.id_procedimento,
          procedimento: {
            id: item.id_procedimento,
            nome: item.desc_procedimento || item.nome,
            codigo: item.codigo,
          },
          data: {
            id_procedimento: item.id_procedimento,
            quantidade_solicitada: item.quantidade_solicitada,
            quantidade_aprovada: item.quantidade_aprovada,
            quantidade_pos_analise: item.quantidade_pos_analise,
            id_processo_motivo_divergencia:
              item?.id_processo_motivo_divergencia || 0,
            valor_unitario: item?.valor_unitario ?? 0.00,
            rol: item?.rol || 0,
            observacao: tools.formatStringHTML(item.observacao),
            justificativa_analise: tools.formatStringHTML(item.justificativa_analise),
          },
        };
      });

    if (processo?.materiais)
      processo.materiais = processo?.materiais?.map((item) => {
        return {
          id: item.id_material,
          material: {
            id: item.id_material,
            nome: item.desc_material || item.nome,
            codigo: item.codigo,
          },
          data: {
            id_material: item.id_material,
            quantidade_solicitada: item.quantidade_solicitada,
            quantidade_aprovada: item.quantidade_aprovada,
            quantidade_pos_analise: item.quantidade_pos_analise,
            valor_unitario: item?.valor_unitario ?? 0.00,
            id_processo_motivo_divergencia:
              item?.id_processo_motivo_divergencia || 0,
            rol: item.rol,
            observacao: tools.formatStringHTML(item.observacao),
            justificativa_analise: tools.formatStringHTML(item.justificativa_analise),
          },
        };
      });

    return processo;
  };

  useEffect(() => {
    const getProcesso = async (id_processo) => {
      if (id_processo === null || processoLoaded) {
        return;
      }

      setProcessoLoaded(true);

      let processo = {};

      if (id_processo) {
        await business
          .getProcesso(id_processo)
          .then((l) => (processo = tratarProcesso(l)));

        if (!processo?.id) {
          return navigate(`/${name}`);
        }

        document.title = processo.id_protocolo;
        setForm(processo);
        setAbas(processo?.abas || []);
      }
    };

    (async () => {
      getProcesso(id);
    })();
  }, [processoLoaded, navigate, name, id]);

  useEffect(() => {
    const getOptions = async () => {
      if (optionsLoaded) {
        return;
      }

      setOptionsLoaded(true);

      let promises = [],
        estados = [],
        sexos = [],
        tiposAnexo = [],
        tiposAnexoCom = [],
        tiposProcesso = [],
        tiposAtendimento = [],
        motivosDeDivergenciaP = [],
        motivosDeDivergenciaPDivergencia = [],
        motivosDeDivergenciaM = [],
        motivosDeDivergenciaMDivergencia = [],
        tipoAnalise = [],
        planoBeneficiario = [];

      estados = business.getEstados();
      sexos = business.getSexo();
      motivosDeDivergenciaP = business.getMotivosDeDivergenciaP();
      motivosDeDivergenciaM = business.getMotivosDeDivergenciaM();
      motivosDeDivergenciaPDivergencia =
        business.getMotivosDeDivergenciaPDivergencia();

      motivosDeDivergenciaMDivergencia =
        business.getMotivosDeDivergenciaMDivergencia();
      tipoAnalise = business.getTipoAnalise();
      planoBeneficiario = business.getPlanoBeneficiario();

      promises.push(
        business.getTipoAnexoCom().then((res) => (tiposAnexoCom = res))
      );
      promises.push(business.getTipoAnexo().then((res) => (tiposAnexo = res)));
      promises.push(
        business.getTiposProcesso().then((res) => (tiposProcesso = res))
      );
      promises.push(
        business.getTiposAtendimento().then((res) => (tiposAtendimento = res))
      );

      await Promise.all(promises);

      setOptions({
        ...{
          estados,
          sexos,
          tiposAnexo,
          tiposAnexoCom,
          tiposProcesso,
          tiposAtendimento,
          motivosDeDivergenciaP,
          motivosDeDivergenciaPDivergencia,
          motivosDeDivergenciaM,
          motivosDeDivergenciaMDivergencia,
          tipoAnalise,
          planoBeneficiario
        },
        ...options,
      });
    };

    (async () => {
      getOptions();
    })();
    // eslint-disable-next-line
  }, [optionsLoaded]);

  useEffect(() => {
    setEtapa(
      (form?.etapas || []).find((etapa) => {
        return parseInt(etapa.id) === parseInt(form?.id_processo_etapa);
      })
    );

    tools
      .diasUteisEntreDatas(form?.data_atendimento, form?.inicio_processo)
      .then((total) => setDiasAteInicio(total)); //barra cinza
    if (!form?.data_conclusao) {
      tools
        .diasUteisEntreDatas(form?.data_atendimento, config.dataHoraAtual())
        .then((total) => setDiasANS(total)); //barra azul escuro
      tools
        .diasUteisEntreDatas(
          form?.inicio_processo_original,
          config.dataHoraAtual()
        )
        .then((total) => setDiasSaasto(total - form?.pausa_dias - 1)); //barra azul claro
    } else {
      tools
        .diasUteisEntreDatas(form?.data_atendimento, form?.data_conclusao)
        .then((total) => setDiasANS(total)); //barra azul escuro
      tools
        .diasUteisEntreDatas(
          form?.inicio_processo_original,
          form?.data_conclusao
        )
        .then((total) => setDiasSaasto(total - form?.pausa_dias - 1)); //barra azul claro
    }
  }, [form, render, form?.responsaveis?.id_desempatador]);

  const [showHistorico, setShowHistorico] = useState(false);

  const toggleComponent = () => {
    setShowHistorico(!showHistorico);
  };

  useEffect(() => {
    const container = document.getElementById("container-status");
    const key = etapaAtual?.key;
    if (
      container &&
      key !== undefined &&
      (etapaAtual?.porcentagem === 40 ||
        key === 11 ||
        etapaAtual?.nome === "Cancelado" ||
        key === 10 ||
        etapaAtual?.nome === "Finalizado")
    ) {
      container.scrollLeft = key * 270;
    }
  }, [etapaAtual]);

  const [updatePushEnable, setUpdatePushEnable] = useState(false);

  useEffect(() => {
    (async () => {
      if (updatePushEnable || !form?.hash_signature) {
        return;
      }

      setUpdatePushEnable(true);

      const wsURL = process.env.REACT_APP_PUSH_WS_URL;
      const push = createPushClient(wsURL);

      console.log(`Push: assinando o canal "saa-processo-${id}"`);

      const channel = push.subscribe(`saa-processo-${id}`);

      channel.bind("update", (payload) => {
        const { id_usuario, hash_signature } = payload;

        if (
          config.user?.id &&
          parseInt(config.user.id) !== parseInt(id_usuario)
        ) {
          console.log(
            `Push: notificando no evento "saa-processo-${id}:update"`,
            hash_signature,
            form?.hash_signature
          );

          setModalData({});

          if (form?.hash_signature !== hash_signature) {
            return setModalData({
              text: "O processo foi alterado. Clique em OK para atualizar.",
              show: true,
              buttonCancel: false,
              onAccept: (e) => {
                e.preventDefault();
                window.location.reload();
              },
              onClose: (e) => {
                e.preventDefault();
                window.location.reload();
              },
            });
          }
        }
      });
    })();
  }, [id, form?.hash_signature, updatePushEnable]);

  return (
    <Layout id="detalhes" className="page detalhes">
      {config.isEspecialista() &&
        form?.responsaveis?.id_desempatador &&
        parseInt(config.user.id) !==
        parseInt(form.responsaveis.id_desempatador) ? (
        <NaoAutorizado />
      ) : (
        <>
          <ModalAlert
            title={modalData?.title}
            text={modalData?.text}
            show={modalData?.show}
            onAccept={modalData?.onAccept}
            onClose={modalData?.onClose}
            buttonCancel={modalData?.buttonCancel}
          />
          {!options?.estados ? <Preloader /> : ""}
          {
            <ModalProcesso
              salvandoDados={salvandoDados}
              show={showModal}
              hideModal={hideModal}
              etapa={etapaAtual}
              processo={form}
              avancarEtapa={avancarEtapa}
            />
          }
          {showModalResponsaveis && (
            <ModalResponsaveis
              show={showModalResponsaveis}
              hideModal={hideModalResponsaveis}
              processo={form}
            />
          )}
          {showModalConvidados && (
            <ModalConvidados
              show={showModalConvidados}
              hideModal={hideModalConvidados}
              processo={form}
            />
          )}
          {showModalTrocaEtapa && (
            <ModalTrocaEtapa
              show={showModalTrocaEtapa}
              hideModal={hideModalTrocaEtapa}
              processo={form}
              onAtualizado={reloadProcesso}
            />
          )}
          <p className="page-title">{title}</p>
          <h1 className="flex ai-fc mb-30 gap-60">
            <div className="flex ai-fc f600-22 gap-10">
              <i
                className="icon icon-arrow-left i-25 pointer"
                onClick={voltar}
              />{" "}
              {form?.id_protocolo}
              {form?.processo_origem && <a href={`${form?.processo_origem_tipo === '3' ? `/junta-medica/` : form?.processo_origem_tipo === '2' ? `/consenso-pre/` : `/opiniao-especializada/`}${form?.processo_origem}`} target="_blank" rel="noreferrer">
                <i className="ml-5 icon icon-question i-25 watermelon pointer" title={`Duplicado a partir de ${form?.id_protocolo.substring(0, 6) + form?.processo_origem} (${form?.processo_origem_tipo_desc})`} />
              </a>}
            </div>

            {/* Progress bar PRAZO SAASTO (Segunda Opinião e Consenso Pré) */}
            {[1, 2].includes(parseInt(form.id_processo_tipo)) &&
              parseInt(form.id_processo_etapa) !== 5 &&
              parseInt(form.id_processo_etapa) !== 12 && (

                <div className="flex fd-fc w-100">
                  {diasSaasto <= form.operadora_dias ? (
                    <ProgressBarList
                      className="w-100"
                      slim={10}
                      initlabel="Prazo säästö:"
                      label={`${diasSaasto > 0 ? diasSaasto : 0} / ${form.operadora_dias}`}
                      list={[
                        {
                          bgcolor: "#0d6efd",
                          borderRadius: "8px",
                          completed: tools.porcentagem(form.operadora_dias, diasSaasto),
                          title: `Decorridos ${diasSaasto > 0 ? diasSaasto : 0} de ${form.operadora_dias} dias do prazo säästö.`,
                        },
                      ]}
                    />
                  ) : (
                    <ProgressBarList
                      className="w-100"
                      slim={10}
                      initlabel="Prazo säästö:"
                      label={`${diasSaasto} / ${form.operadora_dias}`}
                      list={[
                        {
                          bgcolor: "#FF5468",
                          borderRadius: "8px",
                          completed: 100,
                          title: `Expirado prazo säästö.`,
                        },
                      ]}
                    />
                  )}
                </div>

              )}

            {/* Progress bar PRAZO ANS + PRAZO SAASTO (JMO) */}
            {[3].includes(parseInt(form.id_processo_tipo)) &&
              parseInt(form?.id_processo_etapa) !== 5 &&
              parseInt(form?.id_processo_etapa) !== 12 && (

                <div className="flex fd-fc w-100">
                  <span className="fn-12 text-center">
                    Processo encaminhado para säästö no {diasAteInicio}º dia do
                    prazo ANS.
                  </span>
                  {diasANS < form.prazo_processo_tipo_atendimento ? (
                    <ProgressBarList
                      className="w-100"
                      slim={10}
                      initlabel="Prazo ANS:"
                      label={`${diasANS} / ${form.prazo_processo_tipo_atendimento}`}
                      list={[
                        {
                          bgcolor: "#0d6efd",
                          borderRadius: "8px",
                          completed: tools.porcentagem(form.prazo_processo_tipo_atendimento, diasANS),
                          title: `Decorridos ${diasANS} de ${form.prazo_processo_tipo_atendimento} dias do prazo ANS.`,
                        },
                        {
                          bgcolor: "#c9c9c9",
                          borderRadius: "8px 0px 0px 8px",
                          completed: tools.porcentagem(form.prazo_processo_tipo_atendimento, diasAteInicio),
                          title: `Processo encaminhado para säästö no ${diasAteInicio}º dia do prazo ANS.`,
                        },
                      ]}
                    />
                  ) : (
                    <ProgressBarList
                      className="w-100"
                      slim={10}
                      initlabel="Prazo ANS:"
                      label={`${diasANS} / ${form.prazo_processo_tipo_atendimento}`}
                      list={[
                        {
                          bgcolor: "#FF5468",
                          borderRadius: "8px",
                          completed: 100,
                          title: `Expirado prazo de ${form.prazo_processo_tipo_atendimento} dias da ANS.`,
                        },
                      ]}
                    />
                  )}

                  {[3, 4, 19, 24, 26].includes(parseInt(form?.id_processo_etapa_status)) &&
                    <span className="fn-18 text-center">
                      Processo pausado, aguardando interação da operadora.
                    </span>}

                  {(parseInt(form?.id_processo_etapa_status) !== 3 && parseInt(form?.id_processo_etapa_status) !== 4 && parseInt(form?.id_processo_etapa_status) !== 19 && parseInt(form?.id_processo_etapa_status) !== 24 && parseInt(form?.id_processo_etapa_status) !== 26) ?

                    (diasSaasto <= form.operadora_dias &&
                      form?.expiracao_processo >= config.dataAtual()) ? (
                      <ProgressBarList
                        className="w-100"
                        slim={10}
                        initlabel="Prazo säästö:"
                        label={`${diasSaasto > 0 ? diasSaasto : 0} / ${form.operadora_dias}`}
                        list={Array.from({ length: form.operadora_dias }, (_, i) => {
                          const operadora_dias = parseInt(form.operadora_dias)
                          const dia = i + 1
                          const percent = (form.operadora_dias * (dia + i)) - operadora_dias
                          const completed = operadora_dias + 0.5
                          return {
                            bgcolor: diasSaasto >= dia ? "#84a1ff" : "#fff",
                            borderRadius: "8px",
                            left: `${dia > 1 ? percent : 0}%`,
                            completed: tools.porcentagem(completed, 1),
                            title: `Decorridos ${diasSaasto} de ${operadora_dias} dias do prazo säästö.`,
                          }
                        })}
                      />
                    ) : (
                      <ProgressBarList
                        className="w-100"
                        slim={10}
                        initlabel="Prazo säästö:"
                        label={`${diasSaasto} / ${form.operadora_dias}`}
                        list={Array.from({ length: form.operadora_dias }, (_, i) => {
                          const operadora_dias = parseInt(form.operadora_dias)
                          const dia = i + 1
                          const percent = (form.operadora_dias * (dia + i)) - operadora_dias
                          const completed = operadora_dias + 0.5
                          return {
                            bgcolor: "#FF5468",
                            borderRadius: "8px",
                            left: `${dia > 1 ? percent : 0}%`,
                            completed: tools.porcentagem(completed, 1),
                            title: `Expirado prazo de ${operadora_dias} dias da säästö`,
                          }
                        })}
                      />
                    ) : ''}
                </div>

              )}
          </h1>
          {form?.etapas && (
            <div className="w-100 grid col-12 fn-14 jc-fc basic-info">
              <span className="span-3">
                Beneficiário(a): <strong>{form?.beneficiario?.nome}</strong>
              </span>
              <span className="span-3">
                Idade:{" "}
                <strong>
                  {tools.calcularIdade(form?.beneficiario?.nascimento)} anos{" "}
                </strong>
                Sexo:{" "}
                <strong>
                  {form?.beneficiario?.sexo === "M" ? "Masculino" : "Feminino"}
                </strong>
              </span>
              <span className="span-4">
                Especialidade: <strong>{form?.desc_especialidade}</strong>
              </span>
              <span className="span-2">
                Prazo säästö:{" "}
                <strong style={{ color: "#003cff" }}>
                  {tools.formatDate(form?.expiracao_processo)}
                </strong>
              </span>

              <span className="span-3">
                PA : <strong>Dr.(a) {form?.profissional?.nome}</strong>
              </span>
              <span className="span-3">
                Operadora: <strong>{form?.desc_operadora}</strong>
              </span>
              <span className="span-4">
                Área de atuação: <strong>{form?.desc_area_atuacao}</strong>
              </span>
              <span className="span-2">
                Prazo ANS:{" "}
                <strong style={{ color: "#003cff" }}>
                  {tools.formatDate(form?.data_ans)}
                </strong>
              </span>
            </div>
          )}
          <div className="container-status relative">
            {scroll > 0 && (
              <div
                className="arrow-previous"
                onClick={() => setScrollStatus(true)}
              >
                <i className="icon icon-arrow-left i-30" />
              </div>
            )}
            {etapaAtual?.id > 0 && (
              <div id="container-status" className="lista-status">
                {(form?.etapas || []).map((etapa) => {
                  if (etapaAtual?.id && etapaAtual.id === 4 && etapa.ativa) {
                    etapa.porcentagem = 100;
                  }

                  if (etapaAtual?.id && etapaAtual.id === 4 && etapa.id === 5) {
                    return "";
                  }

                  if (etapaAtual?.id && etapaAtual.id === 5 && etapa.ativa) {
                    etapa.porcentagem = 100;
                  }

                  if (etapaAtual?.id && etapaAtual.id === 5 && etapa.id === 4) {
                    return "";
                  }

                  return (
                    <Etapa
                      key={etapa.key}
                      item={etapa}
                      marcadorSLA={form.marcador_sla}
                    />
                  );
                })}
              </div>
            )}
            {etapaAtual?.id > 0 && showNext && (
              <div
                className="arrow-next"
                onClick={() => setScrollStatus(false)}
              >
                <i className="icon icon-arrow-left i-30 rotate-180" />
              </div>
            )}
          </div>
          <div className="flex jc-sb ai-fc mt-30">
            <ul className="abas gap-5">
              {(abas || []).map((row_aba) => {
                return (
                  <li
                    className={`f400-16 ${aba === row_aba.id ? "active" : ""}`}
                    key={row_aba.id}
                    onClick={() => setAba(row_aba.id)}
                  >
                    {row_aba.nome}
                    {row_aba.alertas > 0 && (
                      <span className="f700-12">{row_aba.alertas}</span>
                    )}
                  </li>
                );
              })}
            </ul>
            <div className="flex ai-fc">
              <div className="flex sm-gap mr-20">
                {Number(config.user.tipo) === 1 && (
                  <span className="btn-mais-info pointer" onClick={openModalTrocaEtapa}>
                    <i
                      className="icon icon-step i-20 pointer"
                      title="Trocar etapa"
                    ></i>
                  </span>
                )}
                {config.temPermissao(
                  "processo:processo_convidados:visualizar"
                ) &&
                  form?.id_processo_tipo === "3" && (
                    <span className="btn-mais-info pointer" onClick={openModalConvidados}>
                      <i
                        className="icon icon-users-alt i-20 pointer"
                        title="Convidados"
                      ></i>
                    </span>
                  )}
                <span className="btn-mais-info" onClick={openModalResponsaveis}>
                  <i
                    className="icon icon-users i-20 pointer"
                    title="Responsáveis"
                  ></i>
                </span>
                {!config.isOperadora() &&
                  !config.isEspecialista() && (
                    <span
                      className="btn-mais-info f700-16"
                      onClick={toggleComponent}
                    >
                      <i
                        className="icon icon-book-alt i-20 pointer"
                        title="Histórico"
                      ></i>
                    </span>
                  )}
              </div>
              {etapaAtual?.id &&
                (((etapaAtual.id !== 4 && etapaAtual.id !== 5) &&
                  ((parseInt(form?.id_processo_etapa_status) !== 3 && parseInt(form?.id_processo_etapa_status) !== 4 && parseInt(form?.id_processo_etapa_status) !== 26)
                    || parseInt(config?.user?.tipo) === 1)) ||
                  (![5].includes(etapaAtual.id) &&
                    parseInt(form?.id_processo_tipo) === 1 &&
                    (config.isAdmin() || config.isEnfermeira()))) &&
                form?.permissoes?.includes("etapa:avancar") && (
                  <div className="relative btn-avancar">
                    <button
                      className="btn btn-primary f700-16"
                      onClick={openModal}
                    >
                      Avançar
                    </button>
                  </div>
                )}
              {form?.id &&
                parseInt(form?.id_processo_etapa) === 12 &&
                parseInt(form?.id_processo_etapa_status) === 24 && (
                  <div className="relative btn-avancar">
                    <button
                      className="btn btn-primary f700-16"
                      onClick={enviarProcesso}
                    >
                      Enviar processo
                    </button>
                  </div>
                )}
              {form?.id &&
                (config.isAdmin() || config.isOperadora() || config.isEnfermeira()) &&
                (parseInt(form?.id_processo_etapa_status) === 3 ||
                  parseInt(form?.id_processo_etapa_status) === 4 ||
                  parseInt(form?.id_processo_etapa_status) === 26) && (
                  <div className="relative btn-avancar p-5">
                    <button
                      className="btn btn-primary f700-16"
                      onClick={devolverProcesso}
                    >
                      Devolver à säästö
                    </button>
                  </div>
                )}
            </div>
          </div>
          <div className="mt-30 flex jc-sb gap-20">
            <div className="body">
              <div className="overflow-y scrollfit h-100">
                {form?.desc_operadora ? abaActive() : ""}
              </div>
            </div>
            {showHistorico && <Historico id={id} render={render} />}
          </div>
        </>
      )
      }
    </Layout >
  );
}
